import React from 'react';
import loadable from 'ctrwow_shared/src/utils/loadable';
import Skeleton from 'ctrwow_shared/src/components/ui/Skeleton';

export default function loadableWrapper(component) {
  return loadable(component, { fallback: <Skeleton /> });
}
